// `/` → `/fleet`. The legacy view is still the most useful landing
// page until the operator console pages ship in Phase B.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/fleet" });
  },
});
